import { palette } from '@shared/theme/colorGroups/palette.colors';
import { NovaNavigateIcon } from '../../../assets/icons/NovaNavigateIcon';
import { NovaNotesIcon } from '../../../assets/icons/NovaNotesIcon';
import { NovaRepairIcon } from '../../../assets/icons/NovaRepairIcon';
import { SuggestedQuestion } from '../NovaAIProps';

// Waveform animation constants
export const WAVEFORM_BAR_COUNT = 73;
export const WAVEFORM_STAGGER_MS = 45;
export const WAVEFORM_STAGGER_CYCLE_MS = 350;
export const WAVEFORM_BASE_DURATION_MS = 350;
export const WAVEFORM_DURATION_STEP_MS = 55;
export const WAVEFORM_DURATION_STEP_MOD = 6;
export const WAVEFORM_SCALE_MAX = 1;
export const WAVEFORM_SCALE_MIN = 0.15;
export const WAVEFORM_SCALE_INITIAL = 0.3;

/**
 * Static wave pattern — each bar freezes to this scale when isActive=false.
 * Designed to look like a paused audio waveform: dramatic peaks and valleys
 * with clear visual contrast. Repeats across all WAVEFORM_BAR_COUNT bars.
 */
export const WAVEFORM_STATIC_PATTERN: number[] = [
  0.15, 0.25, 0.55, 0.90, 1.00, 0.85, 0.50, 0.20, 0.10, 0.30,
  0.70, 1.00, 0.80, 0.45, 0.15, 0.10, 0.35, 0.75, 1.00, 0.65,
  0.30, 0.12, 0.20, 0.60, 0.95, 1.00, 0.70, 0.35, 0.15, 0.10,
  0.40, 0.80, 1.00, 0.75, 0.40, 0.18, 0.12, 0.50, 0.90, 0.60,
];

export const novaAICardData = [
  {
    id: 'navigate',
    icon: NovaNavigateIcon, // replace with your icons
    title: 'novaAI.navigateTitle',
    example: 'novaAI.navigateSubTitle',
  },
  {
    id: 'repairHelp',
    icon: NovaRepairIcon,
    title: 'novaAI.repairTitle',
    example: 'novaAI.repairSubTitle',
  },
  {
    id: 'takeNotes',
    icon: NovaNotesIcon,
    title: 'novaAI.notesTitle',
    example: 'novaAI.notesSubTitle',
  },
];

export const userTypes = {
  user: 'user',
  bot: 'bot',
};

export const statuses = {
  listening: 'listening',
} as const;

// BotStructuredMessage table constants
export const VISIBLE_ROWS = 4;
/** Must match tableRow.minHeight in NovaAIChatWindow.styles.ts */
export const ROW_HEIGHT = 52;

// ─── Suggested Questions panel (expanded Nova AI right panel) ─────────────────

/** Mock suggested-question cards — replace with real API data when available */
export const SUGGESTED_QUESTIONS_MOCK: SuggestedQuestion[] = [
  {
    id: 'sq1',
    category: 'DIAGNOSTICS',
    categoryColor: palette.blue.primary,
    iconType: 'wrench',
    question: 'How do I diagnose a squeaking brake noise?',
  },
  {
    id: 'sq2',
    category: 'TROUBLESHOOTING',
    categoryColor: palette.blue.primary,
    iconType: 'warning',
    question: 'What causes an AC system to blow warm air?',
  },
  {
    id: 'sq3',
    category: 'BEST PRACTICES',
    categoryColor: palette.blue.primary,
    iconType: 'check',
    question: 'Best practices for transmission fluid change',
  },
  {
    id: 'sq4',
    category: 'REFERENCE',
    categoryColor: palette.blue.primary,
    iconType: 'book',
    question: 'Torque specifications for wheel lug nuts',
  },
];

/** Capabilities bullet-list shown below the suggested questions */
export const NOVA_CAPABILITIES: string[] = [
  'Search work orders by VIN, plate, or ID',
  'Show active & completed repairs',
  'Diagnostic procedures',
  'Troubleshooting guidance',
  'Repair procedures',
  'Parts identification',
  'Safety guidelines',
];
